<template>
    <div style="max-width: 770px;">
        <form @submit.prevent="validateBeforeSubmit">
            <h3 class="uc">Alrighty, Let’s Get started...</h3>
            <fieldset class="mb-5">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <BasicInput
                            label="What's your email?"
                            id="email"
                            name="email"
                            type="email"
                            v-model="email"
                            :exval="validationAttempt"
                            v-validate="'required|email'"
                            :error="errors.first('email')" />
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <CleaveInput
                            label="What's your zipcode?"
                            id="zipcode"
                            name="zipcode"
                            maxlength="5"
                            type="tel"
                            v-model="zipcode"
                            :cleaveoptions="masks.zipcode"

                            v-validate="{ required: true, validateZip: true, regex: /^[0-9]{5}$/ }"
                            :exval="validationAttempt"
                            :error="errors.first('zipcode')" 
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <LoanSelect
                            label="How much do you want to borrow?"
                            id="loan_amount"
                            name="loan_amount"
                            type="tel"
                            v-model="loan_amount"
                            v-validate="'required'"
                            errormsg="This is a required field"
                            :error="errors.first('loan_amount')" />
                    </div>
                </div>

            </fieldset>

            <div class="light txt-grey p14 my-5" style="max-width: 470px;">By submitting your information, you agree to the terms of our <a href="/legal/privacy" target="_blank">Privacy Policy</a>, <a href="/legal/tos" target="_blank">Terms of Use</a> and <a href="/legal/disclaimer" target="_blank">Disclaimer</a>.</div>

            <div class="my-5 d-flex align-items-center">
                <button class="btn btn-cta btn-red uc" id="form-submit">{{saving ? 'Saving...' : 'Submit'}}</button>
                <div>
                    <transition name="slide">
                        <span class="some-errors" v-if="(errors.items.length != 0 && validationAttempt)">You have some errors</span>
                    </transition>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import axios from 'axios';
import BasicInput from '@/components/form/BasicInput.vue';
import CleaveInput from '@/components/form/CleaveInput.vue';
import LoanSelect from '@/components/form/LoanSelect.vue';

import { mapGetters, mapActions } from "vuex";

export default {
    name: 'FormStep1',
    title: 'Register | Step 1',
    components:{
        BasicInput,
        CleaveInput,
        LoanSelect,
    },
    data() {
	  return {
            validationAttempt: false,
            saving: false,

			email: '',
			zipcode: '',
            loan_amount: '',
            loan_amount_raw: 0,

            masks: {
                zipcode: { numericOnly: true, blocks: [5] },
            }
		}
    },
    methods: {
        ...mapActions(['saveFormData']),
        validateBeforeSubmit() {
            this.saving = true;
            this.validationAttempt = true;
			this.$validator.validate().then((result) => {
        		if (result) {
					this.saveFormData({
                        'email': this.email.toLowerCase(),
                        'zipcode': this.zipcode,
                        'loan_amount' : this.loan_amount,
                        'loan_amount_raw': this.loan_amount_raw,
						'firstStep': true,
                    });
                    this.$router.push({ path: '/registration/processing' });
                } else {
                    this.saving = false;
                }		
      		});
        },

        getLoanAmountValue(){
            const amounts = this.loanAmounts.find(o => o.type === process.env.VUE_APP_SITE_TYPE);
            const loanAmount = amounts.amounts.find(obj => {
                return obj.label === this.loan_amount;
            });
            this.loan_amount_raw = loanAmount.value;
        }
    },
    watch: {
        loan_amount: 'getLoanAmountValue',
    },
    computed: {
        ...mapGetters(["formData", "loanAmounts"]),
    },
    created(){
        this.email = this.formData.email || '';
        this.zipcode = this.formData.zipcode || '';
        this.loan_amount = this.formData.loan_amount || '';
  }
}
</script>

<style>
    
</style>
